import vn from './vn/vi.json';

export default vn;
